import { createContext, useContext, useState } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const [globalData, setGlobalData] = useState({
        apiHost: process.env.NODE_ENV === 'development' 
            ? process.env.REACT_APP_BACKEND_HOST_DEV 
            : process.env.REACT_APP_BACKEND_HOST,
    });

    return (
        <GlobalContext.Provider value={{ globalData, setGlobalData }}>
            {children}
        </GlobalContext.Provider>
    );
};

export default GlobalContext;